import React from 'react'
import { Helmet } from 'react-helmet';


const PagePolicies = () => <>
    <Helmet>
        <title>Terms & policies | Sparkling Email</title>
    </Helmet>
    <section
        className="container d-flex flex-column align-items-center justify-content-center text-center text-dark py-5"
        style={{ minHeight: '60vh' }}
    >
        <section className="col-12 mx-auto text-center mb-4">
            <h1>Terms & policies</h1>
        </section>
        <section className="col-12 col-xl-8 mx-auto text-start mb-4">
            <h2>Legal</h2>
            <ul className="list-unstyled">
                <li><b></b></li>
                <li><b></b></li>
                <li><b></b></li>
                <li><b></b></li>
                <li><b></b></li>
                <li><b></b></li>
                <li><b></b></li>
                <li><b></b></li>
                <li><b></b></li>
            </ul>
        </section>
        <section className="col-12 col-xl-8 mx-auto text-start mb-4">
            <h2>Policies</h2>
            <ul className="list-unstyled">
                <li><b></b></li>
                <li><b></b></li>
                <li><b></b></li>
                <li><b></b></li>
                <li><b></b></li>
                <li><b></b></li>
                <li><b></b></li>
                <li><b></b></li>
                <li><b></b></li>
            </ul>
        </section>
    </section>
</>
export default PagePolicies